import React, { Component } from 'react';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react';

class User extends Component {

    render() {
        const {
            id,
            profileColor,
            profilePicture = "",
            name = "",
            email,
            ppWidth = "auto",
            ppHeight = "auto",
            nameVisible = true,
            profilePicVisible = true,
            ppRound = true,
            style={},
            tooltipVisible=true
        } = this.props;
        const baseUrl = `https://s3.${process.env.REACT_APP_AWS_S3_REGION}.amazonaws.com/${process.env.REACT_APP_AWS_S3_BUCKET}/userprofilephotos/`;
        return (
            <Tooltip placement="top" defaultVisible={!tooltipVisible} title={!tooltipVisible ? '' : name}>
            <div className='profile' style={style}>
                {
                    profilePicVisible ? <div className={ppRound ? 'profile_pic round' : 'profile_pic'} style={{ width: ppWidth, height: ppHeight, background: profileColor !== undefined ? profileColor : '#333', color: '#FFF', display:'flex', alignItems:'center', justifyContent:'center' }}>
                        {
                            profilePicture && profilePicture.trim() !== "" ?
                               
                                    <div className={ppRound ? 'round' : ''} style={{
                                        width: ppWidth,
                                        height: ppHeight
                                    }} >
                                        <img style={{overflow:'hidden', objectFit:'cover', width:"100%", borderRadius:ppRound?'50%':'0%'}} alt={name.substr(0, 1)} src={`${baseUrl}${id}/${profilePicture}`} />
                                    </div> :
                               
                                    <div className={ppRound ? 'round' : ''}>{(name && name.trim() !== "")?name.substr(0, 1):(email && email !== ""?email.substr(0,1):'')}</div>
                               
                        }
                    </div> : null
                }
                {
                    nameVisible ? <div className="profile_name">
                        {
                            name
                        }
                    </div> : null
                }

            </div>
            </Tooltip>

        );
    }
}

export default observer(User);